<template>
  <base-table-wrapper>
    <template #top-buttons>
      <router-link
        tag="button"
        :to="{ name: 'EXCMCaseTypeCreate' }"
        class="btn btn-sm btn-primary float-right mb-1"
      >
        {{$t('buttons.create')}}
      </router-link>
    </template>
    <template #filtering></template>
    <template #body>
      <Loader v-if="isLoading"></Loader>
      <div v-else-if="!isLoading && items.length < 1">
        {{$t('views.excmcasetype.list.noCaseType')}}
      </div>
      <table v-else class="table table-sm table-striped table-hover">
        <thead>
        <tr>
          <th>{{$t('views.excmcasetype.list.table.title')}}</th>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="item in items"
          :key="item['@id']">
          <td>
            <router-link :to="{name: 'EXCMCaseTypeShow', params: { id: item['@id'] }}">
            </router-link>  {{ item['title'] }}
          </td>
          <td>
            <router-link :to="{name: 'EXCMCaseTypeUpdate', params: { id: item['@id'] }}" class="float-right">
              <button class="btn btn-link fa fa-pencil" v-b-tooltip.hover :title="$t('buttons.edit')" aria-hidden="true" />
            </router-link>
          </td>
        </tr>
        </tbody>
      </table>
      <pagination
        v-if="view"
        :view="view"
        @getPage="getPage($event)"
      ></pagination>
    </template>
  </base-table-wrapper>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../Layout/Loader'
import Pagination from '../../Layout/Pagination'
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'

export default {
  components: {
    Loader,
    BaseTableWrapper,
    Pagination
  },
  computed: mapGetters({
    deletedItem: 'excmcasetype/del/deleted',
    error: 'excmcasetype/list/error',
    items: 'excmcasetype/list/items',
    isLoading: 'excmcasetype/list/isLoading',
    view: 'excmcasetype/list/view'
  }),

  beforeCreate () {
    checkPagePermission('configuration', 'EXCMCaseTypeList')
  },

  created () {
    this.getPage()
  },

  methods: mapActions({
    getPage: 'excmcasetype/list/default'
  })
}
</script>
